import { ONEWAY_JOURNEY_TYPE, DOMESTIC, FLIGHT_CLASS_OBJECT } from './text';

export const TODAY = new Date();

export const TODAYPLUSNOOFDAYS = 3;

export const TODAYPLUSDATE = new Date(TODAY.setDate(TODAY.getDate() + TODAYPLUSNOOFDAYS));

export const NULL = null;

export const DEPARTUREDATEFORSEOWITHINNOOFDAYS = 90;

export const SOURCE = {
  iata: 'DEL',
  n: 'Indira Gandhi International Airport',
  ct: 'New Delhi',
  cc: 'IN',
  cnty: 'India',
  con: 'Asia',
  coc: 'AS',
  d: 0,
  lcs: {
    cc: 'CTDEL'
  },
  t: 'airport'
};

export const DESTINATION = {
  iata: 'BLR',
  n: 'Bengaluru International Airport',
  ct: 'Bengaluru',
  cc: 'IN',
  cnty: 'India',
  con: 'Asia',
  coc: 'AS',
  d: 0,
  lcs: {
    cc: 'CTBLR'
  },
  t: 'airport'
};

export const DEPARTURE = TODAYPLUSDATE;

export const ARRIVAL = NULL;

export const PASSENGERS = { adult: 1, child: 0, infant: 0 };

export const FLIGHT_CLASS = FLIGHT_CLASS_OBJECT[0];

export const JOURNEY_TYPE = ONEWAY_JOURNEY_TYPE;

export const TRAVEL_TYPE = DOMESTIC;

export const DEFAULT_SEARCH_WIDGET_DATA = {
  source: SOURCE,
  destination: DESTINATION,
  departure: DEPARTURE,
  arrival: ARRIVAL,
  passengers: PASSENGERS,
  flightClass: FLIGHT_CLASS,
  journeyType: JOURNEY_TYPE,
  selectedFareIdentifier: '',
  isDefaultSrcAndDest: true,
  travelType: TRAVEL_TYPE,
  isAnywhere: true,
  anytime: true,
  travelDate: new Date(),
  tripDuration: 14,
  isNonStop: false,
  isNonStopReturn: false
};

export const OFFERS_DATA = [];

export const RECENT_SEARCH_DATA = [];

export const SEO_DATA = {
  h1: 'Book Domestic and International Flight Tickets',
  title: 'Flight Tickets, Flights Booking at Lowest Airfare, Book Air Tickets-Goibibo'
};

export const POPULAR_CITIES_VALUES = [
  {
    // Delhi
    iata: 'DEL',
    n: 'Indira Gandhi International Airport',
    ct: 'New Delhi',
    cc: 'IN',
    cnty: 'India',
    con: 'Asia',
    coc: 'AS',
    d: 0,
    lcs: {
      cc: 'CTDEL'
    },
    t: 'airport'
  },
  {
    // Mumbai
    iata: 'BOM',
    n: 'Chhatrapati Shivaji International Airport',
    ct: 'Mumbai',
    cc: 'IN',
    cnty: 'India',
    con: 'Asia',
    coc: 'AS',
    d: 0,
    lcs: {
      cc: 'CTBOM'
    },
    t: 'airport'
  },
  {
    // Bangalore
    iata: 'BLR',
    n: 'Bengaluru International Airport',
    ct: 'Bengaluru',
    cc: 'IN',
    cnty: 'India',
    con: 'Asia',
    coc: 'AS',
    d: 0,
    lcs: {
      cc: 'CTBLR'
    },
    t: 'airport'
  },
  {
    // Pune
    iata: 'PNQ',
    n: 'Pune Airport',
    ct: 'Pune',
    cc: 'IN',
    cnty: 'India',
    con: 'Asia',
    coc: 'AS',
    d: 0,
    lcs: {
      cc: 'CTPNQ'
    },
    t: 'airport'
  },
  {
    // Kolkata
    iata: 'CCU',
    n: 'Netaji Subhash Chandra Bose International Airport',
    ct: 'Kolkata',
    cc: 'IN',
    cnty: 'India',
    con: 'Asia',
    coc: 'AS',
    d: 0,
    lcs: {
      cc: 'CTCCU'
    },
    t: 'airport'
  },
  {
    // Goa
    iata: 'GOI',
    n: 'Dabolim Goa International Airport',
    ct: 'Goa',
    cc: 'IN',
    cnty: 'India',
    con: 'Asia',
    coc: 'AS',
    d: 0,
    lcs: {
      cc: 'CTGOI'
    },
    t: 'airport'
  },
  {
    // Hyderabad
    iata: 'HYD',
    n: 'Rajiv Gandhi International Airport',
    ct: 'Hyderabad',
    cc: 'IN',
    cnty: 'India',
    con: 'Asia',
    coc: 'AS',
    d: 0,
    lcs: {
      cc: 'CTHYDERA'
    },
    t: 'airport'
  },
  {
    // Chennai
    iata: 'MAA',
    n: 'Chennai International Airport',
    ct: 'Chennai',
    cc: 'IN',
    cnty: 'India',
    con: 'Asia',
    coc: 'AS',
    d: 0,
    lcs: {
      cc: 'CTMAA'
    },
    t: 'airport'
  }
];

export const SEO_SEARCH_STRING = `gi_source=google&gi_medium=organic&campaign=organic&gocashoffer=true`;

export const BANNER_POSITIONS = [4, 8, 12, 16, 20];

export const DWEB_BANNER_POSITIONS = [3, 7, 11, 15, 19];

export const godata = {
  show_popup: true,
  title: 'Welcome to Goibibo App',
  expiry_date: '',
  toast_msg: 'Code copied: GOAPP. Use it during checkout',
  subtitle: 'Get App exclusive deals and offers!!',
  cta_text: 'Copy code : GOAPP',
  coupon_code: 'GOAPP',
  image_url: 'https://gos3.ibcdn.com/offer-1648801326.png'
};

export const fareOptionsMapping = {
  'ft=sc': 'SC',
  'ft=a': 'AF',
  'student=true': 'ST',
  'ft=d': 'D'
};

export const THANKYOU_PAGE_API_HIT_COUNT = 3;

export const THANK_YOU_PAGE_API_HIT_TIME_INTERVAL = 10000;

export const THANKYOU_PAGE_CONFIRMED_STATUS_LIST = [
  'Confirmed',
  'Booking Confirmed',
  'Trip Confirmed',
  'Booking Successful',
  'Reservation Done',
  'Booking Reserved'
];

export const OMNITURE_SORT = {
  earliest: 'Departure',
  shortest: 'Duration',
  earliestarrival: 'Arrival',
  cheapest: 'Price',
  recommended: 'Best'
};

export const OMNITURE_SORT_MWEB = {
  earliest: 'Early Departure',
  shortest: 'Shortest First',
  cheapest: 'Cheapest First',
  recommended: 'Best First'
};

export const FARE_TYPES = {
  'ft=a': 'Armed Forces',
  'ft=sc': 'Senior Citizen',
  'sf=true': 'Student',
  'ft=d': 'Doctors & Nurses',
  'ft=e': 'Extra Seat'
};

export const FARE_IDENTIFIER = {
  R: 'Regular',
  D: 'Doctors & Nurses',
  AF: 'Defence',
  SC: 'Senior Citizen',
  ST: 'Student'
};

export const CTA = {
  pageLoad: 'pageLoad',
  flightReview: 'flightReview',
  couponApplyCTA: 'couponApplyCTA',
  promoApplyCTA: 'promoApplyCTA',
  proceedAddonsCTA: 'proceedAddonsCTA',
  baggageAndFareRulesCTA: 'baggageAndFareRulesCTA',
  baggageAndCancellationCTA: 'baggageAndCancellationCTA',
  addMealOWCTA: 'addMealOWCTA',
  addMealRTCTA: 'addMealRTCTA',
  baggageCTA: 'baggageCTA',
  fareRuleCTA: 'fareRuleCTA',
  baggageFareRuleCrossCTA: 'baggageFareRuleCrossCTA',
  importantInfoYesCTA: 'importantInfoYesCTA',
  importantInfoNoCTA: 'importantInfoNoCTA',
  charityApplyButtonCTA: 'charityApplyButtonCTA',
  charityRemoveButtonCTA: 'charityRemoveButtonCTA',
  charityInfoCTA: 'charityInfoCTA',
  charityCheckboxSelectedCTA: 'charityCheckboxSelectedCTA',
  charityCheckboxUnselectCTA: 'charityCheckboxUnselectCTA',
  cabFromCityCTA: 'cabFromCityCTA',
  cabToCityCTA: 'cabToCityCTA',
  proceedToPaymentCTA: 'proceedToPaymentCTA',
  insuranceInfoCTA: 'insuranceInfoCTA',
  insureForRsXCTA: 'insureForRsXCTA',
  illRiskItCTA: 'illRiskItCTA',
  coverMeForRSXCTA: 'coverMeForRSXCTA',
  buyZeroCancellationCTA: 'buyZeroCancellationCTA'
  // buyForRsXChecked: 'buyForRsXChecked',
};

export const OMNITURE_SORT_MWEB_LITE = {
  pricesHighToLow: 'Price|High',
  pricesLowToHigh: 'Price|Low',
  bestHighToLow: 'Best',
  bestLowToHigh: 'Best',
  departureTimeMorningToNight: 'Departure|Low',
  departureTimeNightToMorning: 'Departure|High',
  duratonShortToLong: 'Duration|Low',
  duratonLongToShort: 'Duration|High'
};

export const NEW_TAB_DWEB_EXP_ID = 945;

export const EXP_DETAILS = {
  [NEW_TAB_DWEB_EXP_ID]: 'new_tab_dweb'
};

export const GROUNDUP_EXP_VARIENT_ID = 997;

export const GENDER = [
  { name: 'MALE', displayName: 'Male' },
  { name: 'FEMALE', displayName: 'Female' }
];

export const PAX_TYPE = {
  1: 'adult',
  2: 'child',
  3: 'infant'
};

export const CARD_ORDERS = {
  ZERO_CANCELLATION: 'cp',
  INSURANCE: 'ins',
  FREE_DATE_CHANGE: 'fdc'
};

export const LEFT_CARD_ORDERS = {
  FLIGHT_DETAILS: 'f',
  CANCELLATION_POLICY: 'canpen',
  REVIEW_BUNDLE: 'ba',
  GOLUXE: 'giff',
  CANCELLATION_AND_FDC: 'cpfdc',
  ZERO_CANCELLATION: 'cp',
  FREE_DATE_CHANGE: 'fdc',
  SPECIAL_FARES: 'sf',
  FARE_FAMILY_OPTIONS: 'ffo',
  IMPORTANT_INFORMATION: 'in',
  HOTEL_SELL: 'hxsell',
  COVID_REFUND: 'covidRefund',
  MMT_AD: 'mmtad',
  INSURANCE: 'ins',
  CAB: 'ca',
  CHARITY: 'ch',
  GSTIN: 'gstin',
  TRAVELLER: 't'
};

export const RIGHT_CARD_ORDERS = {
  FARE_SUMMARY: 'fs',
  BOOKING_HELP: 'bh',
  GO_CASH: 'gc',
  OFFERS: 'o'
};

export const DEFAULT_LEFT_CARD_ORDERS = [
  LEFT_CARD_ORDERS.FLIGHT_DETAILS,
  LEFT_CARD_ORDERS.CANCELLATION_POLICY,
  LEFT_CARD_ORDERS.REVIEW_BUNDLE,
  LEFT_CARD_ORDERS.GOLUXE,
  LEFT_CARD_ORDERS.CANCELLATION_AND_FDC,
  LEFT_CARD_ORDERS.ZERO_CANCELLATION,
  LEFT_CARD_ORDERS.FREE_DATE_CHANGE,
  LEFT_CARD_ORDERS.SPECIAL_FARES,
  LEFT_CARD_ORDERS.FARE_FAMILY_OPTIONS,
  LEFT_CARD_ORDERS.IMPORTANT_INFORMATION,
  LEFT_CARD_ORDERS.HOTEL_SELL,
  LEFT_CARD_ORDERS.COVID_REFUND,
  LEFT_CARD_ORDERS.MMT_AD,
  LEFT_CARD_ORDERS.INSURANCE,
  `${LEFT_CARD_ORDERS.CAB}-${LEFT_CARD_ORDERS.CHARITY}`,
  LEFT_CARD_ORDERS.GSTIN,
  LEFT_CARD_ORDERS.TRAVELLER,
  LEFT_CARD_ORDERS.MMT_AD
];

export const DEFAULT_RIGHT_CARD_ORDERS = [
  RIGHT_CARD_ORDERS.FARE_SUMMARY,
  RIGHT_CARD_ORDERS.BOOKING_HELP,
  RIGHT_CARD_ORDERS.GO_CASH,
  RIGHT_CARD_ORDERS.OFFERS
];

export const TRAVELLER_KEY_NAME = {
  DOB: 'DOB',
  FIRST_NAME: 'FIRST_NAME',
  LAST_NAME: 'LAST_NAME',
  NATIONALITY: 'NATIONALITY',
  GENDER: 'GENDER',
  PASSPORT_DATE_OF_EXPIRY: 'PASSPORT_DATE_OF_EXPIRY',
  PASSPORT_ISSUING_COUNTRY: 'PASSPORT_ISSUING_COUNTRY',
  PASSPORT_NUMBER: 'PASSPORT_NUMBER',
  FREQUENT_FLIER_AIRLINE: 'FREQUENT_FLIER_AIRLINE',
  FREQUENT_FLIER_NUM: 'FREQUENT_FLIER_NUM',
  DOCUMENT_ID: 'DOCUMENT_ID',
  DOCUMENT_TYPE: 'DOCUMENT_TYPE'
};

export const OMNITURE_ID = 'AMCV_289D7D6662CD510D0A495FC9%40AdobeOrg';
